import React from 'react';

export default class RingsIcon extends React.Component {
  render() {
    return (
      <svg
        className="icon icon-rsvp"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 280.07 199.11"
      >
        <title>RSVP</title>
        <path d="M257.49,0H22.58A22.59,22.59,0,0,0,0,22.58v154a22.59,22.59,0,0,0,22.58,22.58H257.49a22.6,22.6,0,0,0,22.58-22.58V22.58A22.6,22.6,0,0,0,257.49,0Zm0,9a13.46,13.46,0,0,1,6.45,1.64L150.69,109.46c-5.78,5-15.53,5-21.31,0L16.16,10.67A13.39,13.39,0,0,1,22.58,9ZM271,176.53a13.51,13.51,0,0,1-13.54,13.53H22.58A13.54,13.54,0,0,1,9,176.53V22.58a13.4,13.4,0,0,1,1.05-5.19l91.83,80.09L50.18,146a4.52,4.52,0,0,0,6.22,6.57l52-48.73a4.24,4.24,0,0,0,.33-.39l14.75,12.87a26,26,0,0,0,33.16-.05l14.72-12.84a3.52,3.52,0,0,0,.36.41l51.94,48.73a4.5,4.5,0,0,0,3.09,1.23,4.52,4.52,0,0,0,3.13-7.8L178.15,97.48,270,17.39a13.39,13.39,0,0,1,1,5.19Z" />
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Icon/RSVPIcon.js